import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'formatChat',
  standalone: true
})
export class FormatChatPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string): SafeHtml {
    let formatted = value;

    // Handle third-level headers (###), capturing only up to the newline or end of string
    formatted = formatted.replace(/###\s*(.*?)(\n|$)/gm, '<h3>$1</h3>');

    // Handle second-level headers (##), capturing only up to the newline or end of string
    formatted = formatted.replace(/##\s*(.*?)(\n|$)/gm, '<h2>$1</h2>');

    // Handle second-level headers (#), capturing only up to the newline or end of string
    formatted = formatted.replace(/#\s*(.*?)(\n|$)/gm, '<h1>$1</h1>');

    // Replace **text** with <strong>text</strong>
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Replace "* " (bullet points) with <li> tags
    formatted = formatted.replace(/^\* (.+)$/gm, '<li>$1</li>');

    // Replace \t* with <li> and wrap with <ul> tags
    formatted = formatted.replace(/\t\*/g, '<li>').replace(/<li>(.*?)<br>/g, '<ul><li>$1</li></ul>');

    // Ensure the list items are properly wrapped with <ul> tags
    formatted = formatted.replace(/<\/ul><ul>/g, '');

    // Now, replace newlines with <br> after processing headers and lists
    // Replace double newlines with <br><br>
    // formatted = formatted.replace(/\n\n/g, '<br>');

    formatted = formatted.replace(/\n\n/g, '<p></p>');

    // Replace *text* or _text_ with <em>text</em> (italic)
    formatted = formatted.replace(/(?<!\*)\*(?!\*)(.*?)\*(?<!\*)/g, '<em>$1</em>'); // Handles *italic*
    formatted = formatted.replace(/(?<!_)_(?!_)(.*?)_(?<!_)/g, '<em>$1</em>'); // Handles _italic_

    // Replace single newlines with <br>
    // formatted = formatted.replace(/\n/g, '<br>');

    // Convert domain names (e.g., Golf.ai) into clickable links
    // formatted = formatted.replace(/\[(.*?)\]/gi, '<a href="https://$1" target="_blank">$1</a>');

    // Bypass security and return the formatted HTML
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }

}
